import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Verkauft PINE Systems Hardware?",
    a: "PINE Systems liefert kein loses Hardwarepaket. Entscheidend ist das Gesamtsystem aus Erlebnis, Technologie, Content, Betrieb, Einweisung, Schulung, Support und Standortlogik. Hardware ist ein Bestandteil, aber nicht der Kern der Kommunikation. Das Ziel ist ein betreibbares Erlebnisangebot.",
  },
  {
    q: "Welches System passt zu meinem Standort?",
    a: "Das hängt von Fläche, Zielgruppe, Betreiberstruktur, Raumlogik, Infrastruktur, Nutzungsidee und Customer Journey ab. Genau dafür gibt es die Standortprüfung. PVRA, AR_ENA, PINE VR, Hotel VR und PINE Places erfüllen unterschiedliche Standortlogiken.",
  },
  {
    q: "Kann jeder Standort ein PINE Systems Standort werden?",
    a: "Nicht automatisch. Ein Standort muss fachlich geprüft werden. Fläche, Sicherheit, Raumlogik, Gästewege, Personal, Nachfrage und Betreiberstruktur müssen zusammenpassen. PINE Systems prüft zuerst das Potenzial, bevor ein Systemprofil empfohlen wird.",
  },
  {
    q: "Was ist der Unterschied zwischen PVRA und PINE VR?",
    a: "PVRA ist das große Virtual-Reality-Arena-System für größere Freizeitstandorte mit mehreren Erlebnisformaten und bis zu 16 gleichzeitigen Spielern auf zwei Playfields. PINE VR ist das kompakte professionelle VR-Standortprodukt für kleinere Flächen, Eventlocations und bestehende Freizeitbetriebe.",
  },
  {
    q: "Ist AR_ENA eine kleine PVRA?",
    a: "Nein. AR_ENA ist ein eigenes Systemprofil. Der Fokus liegt auf Action, Bewegung, Competition und Teamduellen. AR_ENA richtet sich an Betreiber, die ein sportlich-kompetitives Erlebnisformat suchen.",
  },
  {
    q: "Was ist Hotel VR?",
    a: "Hotel VR ist ein Inhouse-Erlebnis für Hotels, Resorts und touristische Betriebe. Es ermöglicht virtuelle Escape Rooms, kooperative Missionen und buchbare Gästeerlebnisse direkt im Haus. Besonders relevant ist Hotel VR für Familien, Schlechtwetter, Tagungen, Gruppen und Rahmenprogramme.",
  },
  {
    q: "Was ist PINE Places?",
    a: "PINE Places macht reale Orte digital erlebbar. Aus Hotels, Eventlocations, Showrooms, Immobilien, Freizeitstandorten oder Markenräumen entstehen digitale Kopien, die online sichtbar, begehbar, erklärbar und Teil der Customer Journey werden.",
  },
  {
    q: "Was ist der nächste Schritt?",
    a: "Der nächste Schritt ist eine Standortprüfung oder ein Erstgespräch. Dabei klären wir, welches Systemprofil grundsätzlich zu Ihrem Standort, Ihrer Zielgruppe und Ihrer Nutzungsidee passen könnte.",
  },
  {
    q: "Kann ich mit einer kleinen Fläche starten?",
    a: "Ja, je nach Systemprofil. PINE VR und Hotel VR können für kompaktere Flächen interessant sein. Entscheidend ist aber nicht nur die Quadratmeterzahl, sondern auch Bewegungsfreiheit, Raumhöhe, Betreiberlogik und sichere Nutzung.",
  },
  {
    q: "Welche Inhalte können angeboten werden?",
    a: "Je nach Systemprofil sind virtuelle Escape Rooms, kooperative Missionen, Familienformate, Action- und Bewegungsformate, Competition-Erlebnisse, Teambuilding und digitale Markenräume möglich. Die konkrete Auswahl hängt vom Produktprofil und Standort ab.",
  },
  {
    q: "Ist das Angebot für Hotels geeignet?",
    a: "Ja. Hotel VR richtet sich speziell an Hotels, Resorts und touristische Betriebe. Es kann als Schlechtwetterangebot, Familienerlebnis, Tagungsrahmenprogramm oder buchbares Inhouse-Erlebnis genutzt werden.",
  },
  {
    q: "Was bringt PINE Places im Vergleich zu normalen Bildern oder Videos?",
    a: "Bilder zeigen Ausschnitte. Videos laufen linear. PINE Places macht reale Orte digital erfahrbar und kann Kunden aktiv durch Räume, Angebote und Entscheidungswege führen.",
  },
  {
    q: "Kann ich mich melden, wenn ich noch keine Fläche habe?",
    a: "Ja. Wenn Sie mit PINE Systems gründen möchten, aber noch keine passende Fläche haben, kann ein Gründer-Erstgespräch sinnvoll sein. Dabei klären wir, welches Systemprofil grundsätzlich zu Ihrer Idee, Region, Zielgruppe und Betreiberrolle passen könnte.",
  },
  {
    q: "Unterstützt PINE Systems bei der Standortsuche?",
    a: "PINE Systems kann Anforderungen an geeignete Flächen, Standortlogik und Produktfit einordnen. Die konkrete Suche, Anmietung, Prüfung rechtlicher Rahmenbedingungen und wirtschaftliche Entscheidung bleiben beim Gründer beziehungsweise Betreiber.",
  },
  {
    q: "Welches System eignet sich für Gründer?",
    a: "Das hängt von Region, Zielgruppe, Fläche, Betreiberstruktur und Investitionslogik ab. PVRA, AR_ENA und PINE VR können je nach Ausgangslage relevant sein. Hotel VR richtet sich stärker an bestehende Hospitality-Betriebe. PINE Places kann für digitale Standort- und Markenräume relevant sein.",
  },
  {
    q: "Kann ich ein Spiel oder Konzept bei PINE einreichen?",
    a: "Ja. Über das PINE Dev Programm können Entwickler, Studios und kreative Teams Konzepte, Prototypen oder Spiele einreichen. PINE prüft, ob der Inhalt grundsätzlich zu Location-Based Entertainment, Betreiberlogik, Zielgruppen und Systemfähigkeit passt.",
  },
  {
    q: "Garantiert eine Einreichung die Aufnahme ins PINE Systems Portfolio?",
    a: "Nein. Eine Einreichung ist keine Zusage für Test, Aufnahme oder Vergütung. PINE prüft zunächst LBE-Fit, Operator-Fit, Zielgruppenlogik, technische Umsetzbarkeit und mögliches Business-Potenzial.",
  },
  {
    q: "Kann ich als Sales Partner Standorte empfehlen?",
    a: "Ja. Das PINE Sales Partner Programm richtet sich an Personen mit Zugang zu Hotels, Freizeitflächen, Eventlocations, Immobilien, Tourismus, Investoren oder Betreiberstrukturen.",
  },
  {
    q: "Wann entsteht die Sales Partner Provision?",
    a: "Die Provision entsteht nur, wenn ein vorab eingereichter, PINE bisher nicht bekannter Lead zu einem unterzeichneten Vertrag führt. Die konkrete Abwicklung wird vorab individuell bestätigt.",
  },
];

export default function Faq() {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <SEO
        title="PINE Systems FAQ – Häufige Fragen zu Erlebnisstandorten und Markenräumen"
        description="Antworten auf häufige Fragen zu PVRA, AR_ENA, PINE VR, Hotel VR, PINE Places, Standortprüfung und Systemkombinationen."
        jsonLd={faqJsonLd}
      />
      <section className="relative border-b border-[rgba(255,255,255,0.08)] overflow-hidden">
        <div className="absolute inset-0 grid-overlay opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-12 md:pt-36 md:pb-20">
          <div className="overline">FAQ</div>
          <h1 className="font-display text-4xl md:text-6xl uppercase mt-4 max-w-4xl leading-[1.05]">
            Häufige <span className="text-[#18E096]">Fragen.</span>
          </h1>
        </div>
      </section>

      <section>
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-20">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[rgba(255,255,255,0.12)]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-display uppercase tracking-wide hover:text-[#18E096] hover:no-underline py-5">
                  <span>
                    <span className="text-[#18E096] mr-3 font-mono text-sm">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[#AEB7B7] text-base leading-relaxed pb-6 pl-10">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 surface p-8 text-center">
            <h3 className="font-display text-xl md:text-2xl uppercase">Frage nicht dabei?</h3>
            <p className="text-[#AEB7B7] mt-3">Schreiben Sie uns – wir antworten direkt.</p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <Link to="/kontakt" className="btn-primary" data-testid="faq-contact-cta">
                Erstgespräch anfragen <ArrowUpRight size={16} strokeWidth={1.5} />
              </Link>
              <Link to="/standort-pruefen" className="btn-secondary">
                Standortpotenzial prüfen
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
